import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'brt-school-class-compare-block-categories',
  templateUrl: './school-class-compare-block-categories.component.html',
  styleUrls: ['./school-class-compare-block-categories.component.scss']
})
export class SchoolClassCompareBlockCategoriesComponent {

  @Input('data') set setData(val: any) {
    this.currentCategory = val[0].value;
    this.data = val;
  }
  @Output('category-selected') onCategorySelected = new EventEmitter<string>();

  data: any;
  currentCategory: string = "";

  selectCategory(val: string) {
    this.currentCategory = val;
    this.onCategorySelected.emit(val);
  }
}
